export default __webpack_public_path__ + "static/media/affligem_m2.b4acd413.png";